const NUMBER_REGEX = /^\d*\.?\d*$/

export function isNumberFormat(value: string): boolean {
  return NUMBER_REGEX.test(value)
}
